import axios from "axios";

//const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
const BASE_URL = process.env.REACT_APP_API_URL || "https://agrihealth.nuruai.co.ke";

const api = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

// Attach JWT on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("agri_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global response error handler
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("agri_token");
      localStorage.removeItem("agri_user");
      window.dispatchEvent(new Event("auth:logout"));
    }

    return Promise.reject(err);
  }
);

// ✅ ADD THIS HERE — temporary debug logger
// api.interceptors.request.use((config) => {
//   console.log("🚀 REQUEST:", config.method.toUpperCase(), config.url, config.data);
//   return config;
// });

export const authAPI = {
  register: (data) => api.post("/api/v1/auth/register", data),
  login: (data) => api.post("/api/v1/auth/login", data),
  forgotPassword: (email) => api.post("/api/v1/auth/forgot-password", { email }),
  me: () => api.get("/api/v1/auth/me"),
};

export const analyzeAPI = {
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/api/v1/analyze/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getResult: (id) => api.get(`/api/v1/analyze/results/${id}`),
};

export const userAPI = {
  getHistory: () => api.get("/api/v1/user/history"),
  updateProfile: (data) => api.put("/api/v1/user/profile", data),
  changePassword: (data) => api.put("/api/v1/user/password", data),
};

export const paymentsAPI = {
  getPlans: () => api.get("/api/v1/payments/plans"),
  subscribe: (data) => api.post("/api/v1/payments/subscribe", data),
};

export default api;